import React from 'react';

import { Box } from '@tanium/react-box';
import { PillBase, PillBaseProps, TooltipContent } from '@tanium/react-pill';
import { useTheme } from '@tanium/react-theme-context';

import { Border, Fill, Text, UseProvidedColorForBorder } from './themeDefinitions';

export interface Props
  extends Pick<
    PillBaseProps,
    'color' | 'keyForValue' | 'leadingIcon' | 'maxWidth' | 'customTooltipContent' | 'children'
  > {}

const Label = React.memo(
  ({ color, keyForValue, leadingIcon, maxWidth, customTooltipContent, children }: Props) => {
    const theme = useTheme();
    return (
      <PillBase
        {...{
          color: color || Text,
          keyForValue,
          leadingIcon,
          maxWidth,
          alwaysEnableTooltip: !!customTooltipContent,
        }}
        backgroundColor={Fill}
        borderColor={(UseProvidedColorForBorder(theme) && color) || Border}
        tooltipContent={
          customTooltipContent || (
            <TooltipContent keyForValue={keyForValue}>{children}</TooltipContent>
          )
        }
      >
        <Box as="span" fontWeight={keyForValue ? 'bold' : undefined}>
          {children}
        </Box>
      </PillBase>
    );
  },
);
export default Label;
